import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ModalProfileinfoone from "./ModalProfileinfoone";
import ModalReferralsthree from "./ModalReferralsthree";
import ModalReferralstwo from "./ModalReferralstwo";
import ModalVendorReferralsDetailsNewlead from "./ModalVendorReferralsDetailsNewlead";
import Profileeditone from "./Profileeditone";
import Profileinfoone from "./Profileinfoone";
import Profilepasswordone from "./Profilepasswordone";
import VendorReferralsDetailsCommitted from "./VendorReferralsDetailsCommitted";
import VendorReferralsDetailsLeadIdentified from "./VendorReferralsDetailsLeadIdentified";
import VendorReferralsDetailsLost from "./VendorReferralsDetailsLost";
import VendorReferralsDetailsOpportunity from "./VendorReferralsDetailsOpportunity";
import VendorReferralsDetailsProposal from "./VendorReferralsDetailsProposal";
import VendorReferralsDetailsWon from "./VendorReferralsDetailsWon";
import VendorSignup191 from "./VendorSignup191";
import Login from "./Login";
import Referrals from "./Referrals";
import Dashboard from "./Dashboard";
import VendorProfile from "./VendorProfile";
import ReferralsDetails from "./ReferralsDetails";
import ProtectedRoute from "./ProtectedRoute";
import ForgotPassword from "./ForgotPassword";
import NewPassword from "./NewPassword";
import { ToastContainer } from "react-toastify";
import OTPAuthentication from "./OTPAuthentication";
import ChangePassword from "./ChangePassword";
import { checkAuthStatus, ResetNewPassword } from "./redux/slices/authThunks";
import ResetPassword from "./ResetPassword";
import Vendornominate from "./Vendornominate";
import Faq from "./Faq";
import Contactus from "./Contactus";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import ModernSlavery from "./ModernSlavery";
import CookiePolicy from "./CookiePolicy";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import RootLayout from "./RootLayout";
import Help from "./Help";
import InstallPrompt from "./InstallPrompt";

const protect = (component) => <ProtectedRoute>{component}</ProtectedRoute>;

const router = createBrowserRouter([
  { path: "/", element: protect(<Dashboard />) },
  { path: "home", element: protect(<Dashboard />) },
  { path: "profilepasswordone", element: protect(<Profilepasswordone />) },
  { path: "profileeditone", element: protect(<Profileeditone />) },
  { path: "referrals", element: protect(<Referrals />) },
  { path: "referral/:id", element: protect(<ReferralsDetails />) },
  { path: "profileone", element: protect(<VendorProfile />) },
  { path: "modal-referralstwo", element: protect(<ModalReferralstwo />) },
  { path: "modal-referralsthree", element: protect(<ModalReferralsthree />) },
  {
    path: "vendor-referrals-details-lost",
    element: protect(<VendorReferralsDetailsLost />),
  },
  {
    path: "vendor-referrals-details-won",
    element: protect(<VendorReferralsDetailsWon />),
  },
  {
    path: "vendor-referrals-details-committed",
    element: protect(<VendorReferralsDetailsCommitted />),
  },
  {
    path: "vendor-referrals-details-proposal",
    element: protect(<VendorReferralsDetailsProposal />),
  },
  {
    path: "vendor-referrals-details-opportunity",
    element: protect(<VendorReferralsDetailsOpportunity />),
  },
  {
    path: "vendor-referrals-details-lead-identified",
    element: protect(<VendorReferralsDetailsLeadIdentified />),
  },
  {
    path: "modal-vendor-referrals-details-newlead",
    element: protect(<ModalVendorReferralsDetailsNewlead />),
  },
  { path: "modal-profileinfoone", element: protect(<ModalProfileinfoone />) },
  { path: "profileinfoone", element: protect(<Profileinfoone />) },
  { path: "help", element: protect(<Help />) },

  // 🔓 Public Routes (no protection)
  { path: "vendor-nominate", element: <Vendornominate /> },
  { path: "contact-us", element: <Contactus /> },
  { path: "faq", element: <Faq /> },
  { path: "privacy-policy", element: <PrivacyPolicy /> },
  { path: "terms-and-conditions", element: <TermsAndConditions /> },
  { path: "modern-slavery", element: <ModernSlavery /> },
  { path: "cookie-policy", element: <CookiePolicy /> },
  { path: "faq", element: <Faq /> },
  {
    element: <RootLayout />,
    children: [
      // { path: "login", element: <Login /> },
      { path: "vendor-signup", element: <VendorSignup191 /> },
      // { path: "forgot-password", element: <ForgotPassword /> },
      // { path: "new-password", element: <NewPassword /> },
      // { path: "reset-password", element: <ResetPassword /> },
      { path: "otp/:userId", element: <OTPAuthentication /> },
    ],
  },
]);
const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(checkAuthStatus()); // initial check

    const interval = setInterval(() => {
      dispatch(checkAuthStatus());
    }, 25 * 60 * 1000); // every 25 minutes

    return () => clearInterval(interval); // cleanup
  }, [dispatch]);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer position="top-right" autoClose={3000} />
      <InstallPrompt />
    </>
  );
};
export default App;
